var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"mb-0 p-0",attrs:{"id":"loader-v2","role":"status"}},[_c('b-col',{staticClass:"p-0"},[_c('img',{staticClass:"spinner-logo",staticStyle:{"margin":"auto"},attrs:{"src":require("../../../assets/images/login/master_isotipo_VP.svg"),"alt":"logo"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }